import { render, staticRenderFns } from "./ResolFwr2018_2d00_P160.vue?vue&type=template&id=6979d441&"
import script from "./ResolFwr2018_2d00_P160.vue?vue&type=script&lang=js&"
export * from "./ResolFwr2018_2d00_P160.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports